import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

function NotFoundPage(){
    return (
        <> 
            <Container>
                <Row className="bg-white rounded">
                    <Col>
                        <p>404 Not Found Page</p>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default NotFoundPage;